import React, { useState, useEffect } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Login from "./Login"
import Dashboard from "./Dashboard"
import CalendlyAttributionReport from "./reports/CalendlyAttributionReport"
import BuildersRiskSubmissionsReport from "./reports/BuildersRiskSubmissionsReport"
import InsuranceQuoteSubmissionsReport from "./reports/InsuranceQuoteSubmissionsReport"
import RestaurantInsuranceSubmissionsReport from "./reports/RestaurantInsuranceSubmissionsReport"
import WorkersCompensationSubmissionsReport from "./reports/WorkersCompensationSubmissionsReport"
import CommercialAutoInsuranceSubmissionsReport from "./reports/CommercialAutoInsuranceSubmissionsReport"
import BuildersRiskSubmissionForm from "./forms/BuildersRiskSubmissionForm"
import InsuranceQuoteSubmissionForm from "./forms/InsuranceQuoteSubmissionForm"

export default function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch("/auth/current_user")
      .then((res) => res.json())
      .then((data) => {
        if (data.authenticated) {
          setUser(data)
        }
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-gray-600">Loading...</div>
      </div>
    )
  }

  if (!user) {
    return <Login />
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard user={user} />} />
        <Route path="/reports/calendly-attribution" element={<CalendlyAttributionReport user={user} />} />
        <Route path="/reports/builders-risk-submissions" element={<BuildersRiskSubmissionsReport user={user} />} />
        <Route path="/reports/insurance-quote-submissions" element={<InsuranceQuoteSubmissionsReport user={user} />} />
        <Route path="/reports/restaurant-insurance-submissions" element={<RestaurantInsuranceSubmissionsReport user={user} />} />
        <Route path="/reports/workers-compensation-submissions" element={<WorkersCompensationSubmissionsReport user={user} />} />
        <Route path="/reports/commercial-auto-insurance-submissions" element={<CommercialAutoInsuranceSubmissionsReport user={user} />} />
        <Route path="/submissions/builders-risk" element={<BuildersRiskSubmissionForm user={user} />} />
        <Route path="/submissions/insurance-quote" element={<InsuranceQuoteSubmissionForm user={user} />} />
      </Routes>
    </BrowserRouter>
  )
}
